// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 412) return "static/chunks/412-b700fc19911c2be7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"141":"285c1c7bbcef2f79","327":"859b4b4f69c4626d","359":"400eb44974c6a79d","404":"dc45d002aaa1f114","522":"59c68305b850e018","643":"fbb2653c5e2f7809"}[chunkId] + ".js";
};